import React from "react";

import Input from "../../shared/FormElements/Input";
import Phone from "../../assets/icons/phone.svg";
import Email from "../../assets/icons/email.svg";
import Button from "../../shared/Button";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_MINLENGTH,
  VALIDATOR_EMAIL,
} from "../../shared/util/validators";
import { useForm } from "../../shared/hooks/SignUpFrom-hook";

import "./ContactUs.css";

const ContactUs = () => {
  const [formState, inputHandler] = useForm(
    {
      name: {
        value: "",
        isValid: false,
      },
      email: {
        value: "",
        isValid: false,
      },
      message: {
        value: "",
        isValid: false,
      },
    },
    false
  );

  const sendHandler = (e) => {
    e.preventDefault();
    const msg = `
    We got your message. Soon we will return to you.
    Name: ${formState.inputs.name.value}, 
    Email: ${formState.inputs.email.value} 
    Message: ${formState.inputs.message.value}`;
    console.log(msg);
    alert(msg);
  };

  return (
    <div className="section-contact-us">
      <div className="contact-us-content">
        <h2 className="section-title">Contact Us</h2>
        <p className="section-subtitle">
          Your About Us page is vital. It’s often the first stop in any user’s
          journey through a website or blog. It also shouldn’t be their last,
          because first impressions count online just as much as they do in the
          real world. If your visitors aren’t impressed, you can expect them to
          leave without reading your awesome content or completing a conversion
          action (e.g., signing up for your newsletter, making a purchase).
        </p>
        <div className="contact-us-items">
          <div className="contact-us-item-wrapper">
            <div className="contact-us-item-icon">
              <img src={Phone} alt="phone" />
            </div>
            <p className="contact-us-item">+375 (22) 345-00-99</p>
          </div>
          <div className="contact-us-item-wrapper" onClick={() => window.location = 'mailto:onalnihat1986@gmail.com'}>
            <div className="contact-us-item-icon">
              <img src={Email} alt="email" />
            </div>
            <p className="contact-us-item">emailname@gmail.com</p>
          </div>
        </div>
      </div>

      <form className="form-wrapper">
        <div className="input-wrapper">
          <Input
            inputClass="input"
            element="input"
            id="name"
            type="text"
            placeholder="Your name"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Please enter a name."
            onInput={inputHandler}
          />
          <Input
            element="input"
            id="email"
            type="email"
            placeholder="Your email"
            validators={[VALIDATOR_EMAIL()]}
            errorText="Please enter a valid email address."
            onInput={inputHandler}
          />
          <Input
            id="message"
            element="textarea"
            placeholder="What do you want to ask?"
            validators={[VALIDATOR_MINLENGTH(30)]}
            errorText="Please enter a valid description (at least 5 characters)."
            errorClass="textarea-error"
            onInput={inputHandler}
          />
        </div>
        <Button onClick={sendHandler} btn="Send" className="send-btn" disabled={!formState.isValid}/>
      </form>
    </div>
  );
};

export default ContactUs;
